// extracted by mini-css-extract-plugin
export var billingAddress = "_xp-g";
export var contactInfo = "_xp-d";
export var customerInfoContainer = "_xp-c";
export var customerInfoContainerMobile = "_xp-h";
export var customerInfoRow = "_xp-a";
export var customerInfoSection = "_xp-b";
export var fullWidthDividerMobile = "_xp-i";
export var imageContainer = "_xp-1";
export var paymentMethod = "_xp-e";
export var priceText = "_xp-6";
export var priceTextMobile = "_xp-7";
export var product = "_xp-0";
export var productImage = "_xp-2";
export var productInfo = "_xp-4";
export var productMobile = "_xp-9";
export var productTitle = "_xp-8";
export var quantityBadge = "_xp-3";
export var quantityText = "_xp-5";
export var shippingAddress = "_xp-f";